export function OutlineBrushIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0234 2.5918H5.02344V10.5918H19.0234V2.5918Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M5.02344 10.5918V12.5918C5.02344 13.6918 5.92344 14.5918 7.02344 14.5918H10.0234V18.5918C10.0234 19.6918 10.9234 20.5918 12.0234 20.5918C13.1234 20.5918 14.0234 19.6918 14.0234 18.5918V14.5918H17.0234C18.1234 14.5918 19.0234 13.6918 19.0234 12.5918V10.5918H5.02344Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M9.02344 2.5918V5.5918" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M14.0234 2.5918V6.5918" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
